<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11.5" cy="11.5" r="11.5" fill="#F4F4F4"/>
    <path d="M15.0703 7.5135L15.7782 8.22134L8 15.9995L7.29216 15.2917L15.0703 7.5135Z" fill="black"/>
    <path d="M15.7772 15.2784L15.0694 15.9863L7.29118 8.20808L7.99902 7.50024L15.7772 15.2784Z" fill="black"/>
  </svg>
</template>

<script>
  export default {
    name: "DeleteIcon"
  }
</script>